import Month from '../models/months';
import MonthlyOffer from '../models/monthly-offer';

const offersCollection: MonthlyOffer[] = [
  // ##### TEMPLATE
  // {
  //   month: Month.XX,
  //   year: 2025,
  //   offers: [
  //     {
  //       title: '',
  //       description: '',
  //       imgFile: '.png',
  //       offerPrice: 0.0,
  //     },
  //     {
  //       title: '',
  //       description: '',
  //       imgFile: '.png',
  //       offerPrice: 0.0,
  //     },
  //     {
  //       title: '',
  //       description: '',
  //       imgFile: '.png',
  //       offerPrice: 0.0,
  //     },
  //   ],
  // },
  // #####
  {
    month: Month.November,
    year: 2025,
    offers: [
      {
        title: 'ACC akut 600',
        description: 'gegen Husten, 10 Brausetabletten',
        imgFile: 'acc-akut-hustenloeser.png',
        offerPrice: 9.99,
      },
      {
        title: 'Bronchipret',
        description: 'bei Bronchitis, 100 ml Saft',
        imgFile: 'bronchipret.png',
        offerPrice: 8.99,
      },
      {
        title: 'Voltaren forte',
        description: 'Schmerzgel, 100 g',
        imgFile: 'voltaren.schmerzgel-forte-100g-Gel-2025.png',
        offerPrice: 18.99,
      },
    ],
  },
];

export default offersCollection;
